// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__20WmM","header":"ClearentDisclaimer_header__1wawG","inner":"ClearentDisclaimer_inner__3s5Mt"};